import React from 'react';

interface IconProps {
  size?: number;
  className?: string;
}

export const PlatformTargetIcon: React.FC<IconProps> = ({ size = 16, className = '' }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      {/* Outer circle */}
      <circle
        cx="8"
        cy="8"
        r="6.5"
        stroke="#2E7D32"
        strokeWidth="1.5"
        fill="none"
      />
      {/* Middle circle */}
      <circle
        cx="8"
        cy="8"
        r="4"
        stroke="#2E7D32"
        strokeWidth="1.5"
        fill="none"
      />
      {/* Inner circle (bullseye center) */}
      <circle
        cx="8"
        cy="8"
        r="1.5"
        fill="#2E7D32"
      />
      {/* Crosshair - horizontal */}
      <line
        x1="1"
        y1="8"
        x2="4"
        y2="8"
        stroke="#2E7D32"
        strokeWidth="1.2"
        strokeLinecap="round"
      />
      <line
        x1="12"
        y1="8"
        x2="15"
        y2="8"
        stroke="#2E7D32"
        strokeWidth="1.2"
        strokeLinecap="round"
      />
      {/* Crosshair - vertical */}
      <line
        x1="8"
        y1="1"
        x2="8"
        y2="4"
        stroke="#2E7D32"
        strokeWidth="1.2"
        strokeLinecap="round"
      />
      <line
        x1="8"
        y1="12"
        x2="8"
        y2="15"
        stroke="#2E7D32"
        strokeWidth="1.2"
        strokeLinecap="round"
      />
    </svg>
  );
};
